import { render, staticRenderFns } from "./ExtensibleEditView.vue?vue&type=template&id=1850d18e&scoped=true"
import script from "./ExtensibleEditView.vue?vue&type=script&lang=js"
export * from "./ExtensibleEditView.vue?vue&type=script&lang=js"
import style0 from "./ExtensibleEditView.vue?vue&type=style&index=0&id=1850d18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1850d18e",
  null
  
)

export default component.exports